import { ref, watch } from 'vue';
import { useIdle } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import useUserStore from '@/store/user';

/** 無操作超過該時長後上報離線 */
const IDLE_MS = 60 * 60 * 1000;

/**
 * 登錄後上報在線；60 分鐘無操作上報離線；恢復操作後再上報在線
 */
export function useSaleOnlineStatus() {
  const userStore = useUserStore();
  const { hasLogin } = storeToRefs(userStore);
  const { idle } = useIdle(IDLE_MS);
  const lastOnline = ref(null);

  watch(
    [hasLogin, idle],
    ([loggedIn, isIdle]) => {
      if (!loggedIn) {
        lastOnline.value = null;
        return;
      }

      const online = isIdle ? 0 : 1;
      if (lastOnline.value === online) return;
      lastOnline.value = online;
      userStore.reportOnlineStatus(online);
    },
    { immediate: true },
  );
}
